<template>
    <div id="app">
        <main role="main" class="main-cont">
            <div class="row m-0 main-section">
                <!--<link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.6.3/css/all.css" integrity="sha384-UHRtZLI+pbxtHCWp1t77Bi1L4ZtiqrqD80Kn4Z8NTSRyMA2Fd33n5dQ8lWUE00s/" crossorigin="anonymous">-->
                <div class="col-sm-12 right-section homebody">

                    <div class="row" style="margin-top:30px;">
                        <div class="col-sm-2 ">
                        </div>
                        <div class="col-sm-8 card bg-light">
                            <div v-if="loading">
                                <img class="progressLoader" />
                            </div>
                            <h4 class="mb-4 label-font-design"> MEMO </h4>
                            <div class="panelDiv">
                                <form data-vv-scope="generateForm">
                                    <div class="form-group">
                                        <div class="row">
                                            <div class="col-sm-3 label-font-design">
                                                <label class="control-label" for="place">Client Name  *</label>
                                            </div>
                                            <div class="col-sm-5 ">
                                                <select v-on:change="HandleClientChange()" v-model="selectedClient" class="form-control selectarrow" name="selectedClient" v-validate="'required'" :class="{'is-invalid':errors.has('generateForm.selectedClient')}">
                                                    <option value="" selected disabled>Please Select Client Name</option>
                                                    <option v-for="clt in clientmap" :key="clt.id" v-bind:value="{ id: clt.id, text: clt.clientName }">{{ clt.clientName }}</option>
                                                </select>
                                                <span v-show="errors.has('generateForm.selectedClient')" class="text-danger">Please select the Client Name</span>
                                            </div>
                                            <div class="col-sm-4">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="floating-label d-flex flex-column flex-md-row"></div>
                                    <div class="floating-label d-flex flex-column flex-md-row"></div>
                                    <div class="floating-label d-flex flex-column flex-md-row"></div>
                                    <div class="floating-label d-flex flex-column flex-md-row"></div>
                                    <div class="form-group" data-vv-scope="uploadForm">
                                        <div class="row">
                                            <div class="col-sm-3 label-font-design">
                                                <label class="control-label" for="place">File (.xlsx) *</label>
                                            </div>
                                            <div class="col-sm-5 ">
                                                <div class="file-upload">
                                                    <div class="file-select" :class="{'is-invalid':errors.has('generateForm.chooseFile')}">
                                                        <div class="file-select-name" id="noFileUS">
                                                            {{MEMOUploadedFile}}
                                                        </div>
                                                        <input type="file"
                                                               name="chooseFile"
                                                               id="MEMOFile"
                                                               ref="MEMOFile"
                                                               v-on:change="handleMEMOFile()"
                                                               v-validate="`required|size:${fileSize}`"
                                                               accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet">
                                                        <div class="file-select-button" id="fileName">Browse</div>
                                                    </div>
                                                </div>
                                                <span v-show="errors.has('generateForm.chooseFile')" class="text-danger">Please upload the File</span>
                                            </div>
                                            <div class="col-sm-4">
                                                <button class="btn btn-primary mr-4" v-bind:disabled="btnDisabled" @click.prevent="Fetch('uploadForm')">Upload</button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group" v-if="renderMEMOUploadDiv" data-vv-scope="applicationDetailsForm">
                                        <div class="floating-label d-flex flex-column flex-md-row"></div>
                                        <div class="floating-label d-flex flex-column flex-md-row"></div>
                                        <div class="row">
                                            <div class="col-sm-2">
                                            </div>
                                            <div class="col-sm-8" style="padding-left: 5px;padding-right:5px;">
                                                <div v-for="(workbookdata, index) in memoworkbookarray.fileDetails" v-bind:key="index.id" class="row" v-bind:class="{boxed:isBoxed}">
                                                    <div class="row col-sm-12">
                                                        <div class="col-sm-10 label-font-design">
                                                            <label style="font-weight:bold;" class="mb-3">{{workbookdata.fileName}}</label>
                                                        </div>
                                                        <div class="col-sm-2">
                                                        </div>
                                                    </div>
                                                    <div class="floating-label d-flex flex-column flex-md-row"></div>
                                                    <div class="floating-label d-flex flex-column flex-md-row"></div>
                                                    <div class="floating-label d-flex flex-column flex-md-row"></div>
                                                    <div class="floating-label d-flex flex-column flex-md-row"></div>
                                                    <div v-bind:id="'box' + workbooksheetdata.id" v-for="(workbooksheetdata, index) in workbookdata.sheetDetails" v-bind:key="index.id" class="row" v-bind:class="{boxed:isBoxed}">
                                                        <div class="row col-sm-12">
                                                            <div class="col-sm-3 label-font-design">
                                                                <label style="font-weight:bold;" class="mb-3">{{workbooksheetdata.labelName}}</label>
                                                            </div>
                                                            <div class="col-sm-7">
                                                                <select class="form-control col-sm-12 selectarrow " v-model="workbooksheetdata.sheetName">
                                                                    <option v-for="(worksheets, value) in sheetNames" v-bind:key="value">
                                                                        {{ worksheets.sheetname }}
                                                                    </option>
                                                                </select>
                                                            </div>
                                                            <div class="col-sm-2">
                                                                <button class="btn" v-if="!isSkipDisabled" v-bind:class="{skipbtntype:btnskip}" v-bind:id="'skip' + workbooksheetdata.id" @click.prevent="handleSkipEvent($event,workbooksheetdata.id)">Skip</button>
                                                            </div>
                                                        </div>
                                                        <div class="floating-label d-flex flex-column flex-md-row"></div>
                                                        <div class="floating-label d-flex flex-column flex-md-row"></div>
                                                        <div class="floating-label d-flex flex-column flex-md-row"></div>
                                                        <div class="floating-label d-flex flex-column flex-md-row"></div>
                                                        <div class="row col-sm-12">
                                                            <div class="col-sm-12 dp-inline-fx">
                                                                <div class="col-sm-3"></div>
                                                                <div class="col-sm-4  pl-0">
                                                                    <div class="mt-2 new-form">
                                                                        <div class="floating-label d-flex flex-column flex-md-row">
                                                                            <input v-model="workbooksheetdata.columnStart"
                                                                                   class="floating-input"
                                                                                   type="number"
                                                                                   placeholder=" "
                                                                                   name="colStart"
                                                                                   v-validate="'required|colParameter'"
                                                                                   v-on:keypress="isNumber($event)">
                                                                            <span class="highlight"></span>
                                                                            <label>Start Column</label>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div class="col-sm-4  pl-0">
                                                                    <div class="mt-2 new-form">
                                                                        <div class="floating-label d-flex flex-column flex-md-row">
                                                                            <input v-model='workbooksheetdata.columnEnd'
                                                                                   class="floating-input"
                                                                                   type="number"
                                                                                   placeholder=" "
                                                                                   name="colEnd"
                                                                                   v-validate="'required|colParameter'"
                                                                                   v-on:keypress="isNumber($event)">
                                                                            <span class="highlight"></span>
                                                                            <label>End Column</label>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div class="col-sm-1"></div>
                                                            </div>
                                                        </div>
                                                        <div class="floating-label d-flex flex-column flex-md-row"></div>
                                                        <div class="floating-label d-flex flex-column flex-md-row"></div>
                                                        <div class="floating-label d-flex flex-column flex-md-row"></div>
                                                        <div class="floating-label d-flex flex-column flex-md-row"></div>
                                                        <div class="row col-sm-12">
                                                            <div class="col-sm-12 dp-inline-fx">
                                                                <div class="col-sm-3"></div>
                                                                <div class="col-sm-4  pl-0">
                                                                    <div class="mt-2 new-form">
                                                                        <div class="floating-label d-flex flex-column flex-md-row">
                                                                            <input v-model='workbooksheetdata.rowStart'
                                                                                   class="floating-input"
                                                                                   type="number"
                                                                                   placeholder=" "
                                                                                   name="rowStart"
                                                                                   v-validate="'required|rowParameter'"
                                                                                   v-on:keypress="isNumber($event)">
                                                                            <span class="highlight"></span>
                                                                            <label>Start Row</label>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div class="col-sm-4  pl-0">
                                                                    <div class="mt-2 new-form">
                                                                        <div class="floating-label d-flex flex-column flex-md-row">
                                                                            <input v-model='workbooksheetdata.rowEnd'
                                                                                   class="floating-input"
                                                                                   type="number"
                                                                                   placeholder=" "
                                                                                   name="rowEnd"
                                                                                   v-validate="'required|rowParameter'"
                                                                                   v-on:keypress="isNumber($event)">
                                                                            <span class="highlight"></span>
                                                                            <label>End Row</label>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div class="col-sm-1"></div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-2">
                                            </div>
                                            <div class="floating-label d-flex flex-column flex-md-row"></div>
                                            <div class="floating-label d-flex flex-column flex-md-row"></div>
                                        </div>
                                        <div class="row">
                                            <div class="col-sm-3">
                                            </div>
                                            <div class="col-sm-7">
                                                <span v-if="errors.has('generateForm.rowEnd' ) || errors.has('generateForm.rowStart') || errors.has('generateForm.colStart') || errors.has('generateForm.colEnd')" class="text-danger">Please enter the mandatory parameters</span>
                                            </div>
                                            <div class="col-sm-2"></div>
                                        </div>
                                    </div>
                                    <div class="row" style="margin-top:30px;">
                                        <div class="col-sm-2 ">
                                        </div>
                                        <div class="container">
                                            <hr>
                                            <div class="form-group">
                                                <div class="row">
                                                    <div class="col-sm-3 label-font-design">
                                                        <label class="control-label" for="place">Place</label>
                                                    </div>
                                                    <div class="col-sm-5 ">
                                                        <input type="text" class="form-control border input-control-border" :maxlength="maxCharacter" v-validate="'alpha_spaces'" id="place" v-model="place" placeholder="Enter Place" name="place">
                                                        <span v-show="errors.has('generateForm.place')" class="text-danger ">Place must be alphabets</span>
                                                    </div>
                                                    <div class="col-sm-4 ">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-group">
                                                <div class="row">
                                                    <div class="col-sm-3 label-font-design">
                                                        <label class="control-label" for="date">Date (dd-MM-yyyy)*</label>
                                                    </div>
                                                    <div class="col-sm-5 ">
                                                        <input type="date" class="form-control border input-control-border" id="date" v-model="date" placeholder="Enter Date" name="date" v-validate="'required'" :class="{'is-invalid': errors.has('generateForm.date')}">
                                                        <span v-show="errors.has('generateForm.date')" class="text-danger ">Please select the Date</span>
                                                    </div>
                                                    <div class="col-sm-4 ">

                                                    </div>
                                                </div>

                                            </div>
                                            <div class="form-group">
                                                <div class="row">
                                                    <div class="col-sm-3 label-font-design">
                                                        <label class="control-label" for="sender1Name">Sender 1 Name</label>
                                                    </div>
                                                    <div class="col-sm-5">
                                                        <input type="text" :maxlength="maxCharacter" v-validate="'alpha_spaces'" class="form-control border input-control-border" id="sender1Name" v-model="sender1Name" placeholder="Enter Sender Name" name="sender1Name">
                                                        <span v-show="errors.has('generateForm.sender1Name')" class="text-danger ">Name must be alphabets</span>
                                                    </div>
                                                    <div class="col-sm-4 ">

                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-group">
                                                <div class="row">
                                                    <div class="col-sm-3 label-font-design">
                                                        <label class="control-label" for="sender1Designation">Sender 1 Designation</label>
                                                    </div>
                                                    <div class="col-sm-5">
                                                        <input type="text" class="form-control border input-control-border" :maxlength="maxCharacter" v-validate="'alpha_spaces'" id="sender1Designation" v-model="sender1Designation" placeholder="Enter Sender Designation" name="sender1Designation">
                                                        <span v-show="errors.has('generateForm.sender1Designation')" class="text-danger ">Designation must be alphabets</span>
                                                    </div>
                                                    <div class="col-sm-4">

                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-group">
                                                <div class="row">
                                                    <div class="col-sm-3 label-font-design">
                                                        <label class="control-label" for="sender2Name">Sender 2 Name</label>
                                                    </div>
                                                    <div class="col-sm-5">
                                                        <input type="text" class="form-control border input-control-border" :maxlength="maxCharacter" v-validate="'alpha_spaces'" id="sender2Name" v-model="sender2Name" placeholder="Enter Sender Name" name="sender2Name">
                                                        <span v-show="errors.has('generateForm.sender2Name')" class="text-danger ">Name must be alphabets</span>
                                                    </div>
                                                    <div class="col-sm-4 ">

                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-group">
                                                <div class="row">
                                                    <div class="col-sm-3 label-font-design">
                                                        <label class="control-label" for="email">Sender 2 Designation</label>
                                                    </div>
                                                    <div class="col-sm-5">
                                                        <input type="text" class="form-control border input-control-border" :maxlength="maxCharacter" v-validate="'alpha_spaces'" id="sender2Designation" v-model="sender2Designation" placeholder="Enter Sender Designation" name="sender2Designation">
                                                        <span v-show="errors.has('generateForm.sender2Designation')" class="text-danger ">Designation must be alphabets</span>
                                                    </div>
                                                    <div class="col-sm-4 ">

                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-group">
                                                <div class="row">
                                                    <div class="col-sm-3 label-font-design">
                                                        <label class="control-label" for="senderName"> Recipient Name</label>
                                                    </div>
                                                    <div class="col-sm-5">
                                                        <input type="text" class="form-control border input-control-border" :maxlength="maxCharacter" v-validate="'alpha_spaces'" id="recipientName" v-model="recipientName" placeholder="Enter Recipient Name" name="recipientName">
                                                        <span v-show="errors.has('generateForm.recipientName')" class="text-danger ">Recipient name must be alphabets</span>
                                                    </div>
                                                    <div class="col-sm-4 ">

                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-group">
                                                <div class="row">
                                                    <div class="col-sm-3 label-font-design">
                                                        <label class="control-label" for="addressLine1">Address Line 1</label>
                                                    </div>
                                                    <div class="col-sm-5">
                                                        <input type="text" class="form-control border input-control-border" :maxlength="maxCharacter" id="addressLine1" v-validate="'address'" v-model="addressLine1" placeholder="Enter Address Line 1" name="addressLine1">
                                                    </div>
                                                    <div class="col-sm-4 ">

                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-group">
                                                <div class="row">
                                                    <div class="col-sm-3 label-font-design">
                                                        <label class="control-label" for="addressLine2">Address Line 2</label>
                                                    </div>
                                                    <div class="col-sm-5">
                                                        <input type="text" class="form-control border input-control-border" :maxlength="maxCharacter" id="addressLine2" v-validate="'address'" v-model="addressLine2" placeholder="Enter Address Line 2" name="addressLine2">
                                                    </div>
                                                    <div class="col-sm-4 ">

                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-group">
                                                <div class="row">
                                                    <div class="col-sm-3 label-font-design">
                                                        <label class="control-label" for="addressLine3">Address Line 3</label>
                                                    </div>
                                                    <div class="col-sm-5">
                                                        <input type="text" class="form-control border input-control-border" :maxlength="maxCharacter" v-validate="'address'" id="addressLine3" v-model="addressLine3" placeholder="Enter Address Line 3" name="addressLine3">
                                                    </div>
                                                    <div class="col-sm-4 ">

                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-group">
                                                <div class="row">
                                                    <div class="col-sm-3"></div>
                                                    <div class="col-sm-5">
                                                        <span v-if="errors.has('generateForm.addressLine1') || errors.has('generateForm.addressLine2') || errors.has('generateForm.addressLine3')"
                                                              class="text-danger">Please enter a valid address</span>
                                                    </div>
                                                    <div class="col-sm-4">

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="showUpdateWarning" class="alert alert-warning alert-dismissible fade show col-sm-8">
                                        <button type="button" class="close" data-dismiss="alert">&times;</button>
                                        <strong> {{this.memoMessage}} </strong>
                                    </div>
                                    <div class="row">
                                        <div class="col text-center">
                                            <button class="btn btn-primary" @click.prevent="Generate('generateForm')" :disabled="errors.any()">Generate</button>
                                        </div>
                                    </div>
                                    <div v-if="showMemowarning" class="col-sm-6 alert alert-danger alert-dismissible fade show" style="margin-left:20px;">
                                        <button type="button" class="close" data-dismiss="alert">&times;</button>
                                        <strong> Memo generation Failed !! </strong>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div class="col-sm-2 ">
                        </div>
                    </div>
                    <div class="row" v-if="renderSendMEMODiv" style="margin-top:30px;">
                        <div class="col-sm-2 ">
                        </div>
                        <div class="col-sm-8 card bg-light">
                            <div v-if="sendloading">
                                <img class="progressLoader" />
                            </div>
                            <div class="panelDiv">
                                <div class="floating-label d-flex flex-column flex-md-row"></div>
                                <div class="row">
                                    <div class="col-sm-4 col-md-4 label-font-design">
                                        Client :
                                    </div>
                                    <div class="col-sm-8 col-md-8 label-font-design">
                                        Memo :
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-4 col-md-4 memoTitle">
                                        {{memoClientName}}
                                    </div>
                                    <div class="col-sm-8 col-md-8 memoTitle" style="cursor: pointer;">
                                        <!-- <a v-on:click=" DownloadMemoFile(memoName)"> {{memoName}}</a> memoLink -->


                                        <strong>
                                            <a :href="memoLink" class="alert-link" style="cursor: pointer;">Click here to download </a>
                                        </strong>

                                    </div>
                                </div>
                                <div class="floating-label d-flex flex-column flex-md-row"></div>
                                <div class="floating-label d-flex flex-column flex-md-row"></div>
                                <form data-vv-scope="sendForm" v-on:submit.prevent="Send">
                                    <div class="row">
                                        <div class="col-sm-2 label-font-design">
                                            <label class="control-label" for="subject">To  *</label>
                                        </div>
                                        <div class="col-sm-6 ">
                                            <input type="text" class="form-control border input-control-border" id="to" placeholder="" name="to" v-model="mailto" v-validate="'required'" v-bind:class="{'form-control': true, 'error': errors.has('sendForm.to') }">
                                            <span v-show="errors.has('sendForm.to')" class="text-danger">{{ errors.first('sendForm.to') }}</span>
                                        </div>
                                        <div class="col-sm-4 ">
                                        </div>
                                    </div>
                                    <div class="floating-label d-flex flex-column flex-md-row"></div>
                                    <div class="floating-label d-flex flex-column flex-md-row"></div>
                                    <div class="row">
                                        <div class="col-sm-2 label-font-design">
                                            <label class="control-label" for="email">Subject  *</label>
                                        </div>
                                        <div class="col-sm-6 ">
                                            <input type="text" class="form-control border input-control-border" :maxlength="maxCharacter" id="subject" placeholder="" name="subject" v-model="mailsubject" v-validate="'required'" v-bind:class="{'form-control': true, 'error': errors.has('sendForm.subject') }">
                                            <span v-show="errors.has('sendForm.subject')" class="text-danger">{{ errors.first('sendForm.subject') }}</span>
                                        </div>
                                        <div class="col-sm-4 ">
                                        </div>
                                    </div>
                                    <div class="floating-label d-flex flex-column flex-md-row"></div>
                                    <div class="floating-label d-flex flex-column flex-md-row"></div>
                                    <div class="row">
                                        <div class="col-sm-8">
                                            <textarea class="form-control input-control-border" :maxlength="emailBody" id="body" placeholder="Please write the mail here.." name="body" style="height:120px;" v-model="mailbody"></textarea>
                                        </div>
                                    </div>
                                    <div class="floating-label d-flex flex-column flex-md-row"></div>
                                    <div class="floating-label d-flex flex-column flex-md-row"></div>
                                    <div class="row">
                                        <div class="col text-center">
                                            <button class="btn btn-primary">Send</button>
                                        </div>
                                    </div>
                                </form>
                                <div class="row">
                                    <div class="col-sm-3">
                                    </div>
                                    <div class="col-sm-6 emailMsg">
                                        <div v-if="showEmailSuccess" class="alert alert-success">
                                            <strong>
                                                Email Sent Successfully !!
                                            </strong>
                                        </div>
                                        <div v-if="showEmailWarning" class="alert alert-danger alert-dismissible fade show">
                                            <button type="button" class="close" data-dismiss="alert">&times;</button>
                                            <strong> Issue While Sending Email !! </strong>
                                        </div>
                                    </div>
                                    <div class="col-sm-3">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-2 ">
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>
<script>
    import CommonService from '../../services/SharedService/common.service.js';
    import MEMO1Service from '../../services/MEMOService/MEMO1.service.js';
    import { ValidationProvider } from 'vee-validate';
    import VeeValidate from 'vee-validate';
    import AppValidations from "../../services/validation.js";
    import { EnvironmentConfig } from '../../services/constants.js';
    import Algorithm from "../../services/Algorithm.js";


    export default {
        name: 'MEMO',
        data() {
            return {
                selectedClient: '',
                MEMOUploadedFile: "Choose file (Max file size 100 MB)",
                loading: false,
                sendloading: false,
                clientmap: [],
                renderSendMEMODiv: false,
                memoClientName: '',
                memoName: '',
                memoLink: '',
                place: '',
                date: '',
                sender1Name: '',
                sender1Designation: '',
                sender2Name: '',
                sender2Designation: '',
                recipientName: '',
                mailto: '',
                mailsubject: '',
                mailbody: '',
                addressLine1: '',
                addressLine2: '',
                addressLine3: '',
                showEmailSuccess: false,
                showEmailWarning: false,
                validationerrors: [],
                divError: false,
                isValid: false,
                btnDisabled: true,
                showMemowarning: false,
                memoworkbookarray: [],
                clonememoworkbookarray: [],
                sheetNames: [],
                renderMEMOUploadDiv: false,
                btnskip: true,
                isBoxed: true,
                isSkipDisabled: true,
                maxCharacter: 100,
                emailBody: 2000,
                fileSize: EnvironmentConfig._FileSize,
                showUpdateWarning: false,
                memoMessage: ''
            }
        },
        components: {
            ValidationProvider,
            VeeValidate

        },
        created: function () {
            localStorage.setItem('route', this.$route.name);
            this.loadClientNames();
        },
        mixins: [CommonService, MEMO1Service, AppValidations, Algorithm],
        methods: {
            loadClientNames() {
                this.ClientMapping("memo").then(response => {
                    if (response) {
                        this.clientmap = response.data;
                    }
                });
            },
            handleMEMOFile() {
                this.MEMOFile = this.$refs.MEMOFile.files[0];
                this.MEMOUploadedFile = this.MEMOFile.name;
                this.btnDisabled = false;
            },
            HandleClientChange() {
                this.$validator.reset();
                this.errors.clear();
                this.MEMOUploadedFile = "Choose file (Max file size 100 MB)",
                    this.renderSendMEMODiv = false,
                    this.renderMEMOUploadDiv = false,
                    this.memoClientName = '',
                    this.memoName = '',
                    this.memoLink = '',
                    this.place = '',
                    this.date = '',
                    this.sender1Name = '',
                    this.sender1Designation = '',
                    this.sender2Name = ''
                this.sender2Designation = '',
                    this.addressLine1 = '';
                this.addressLine2 = '';
                this.addressLine3 = '';
                this.validationerrors = [];
                this.recipientName = '';
            },
            Fetch() {
                function deepCopy(oldObj) {
                    var newObj = oldObj;
                    if (oldObj && typeof oldObj === 'object') {
                        newObj = Object.prototype.toString.call(oldObj) === "[object Array]" ? [] : {};
                        for (var i in oldObj) {
                            newObj[i] = deepCopy(oldObj[i]);
                        }
                    }
                    return newObj;
                }
                this.loading = true;
                const formData = new FormData();
                formData.append("File", this.MEMOFile);
                formData.append("FileType", "memo");
                formData.append("TableName", "Memo.BaseMemo");
                formData.append("FirstName", localStorage.getItem('firstName'));
                formData.append("LastName", localStorage.getItem('lastName'));
                formData.append("UserName", localStorage.getItem('userName'));
                this.ImportUploadedFile(formData).then(Response => {
                    if (Response) {
                        this.loading = false;
                        this.memoworkbookarray = Response.data;
                        this.renderMEMOUploadDiv = true;
                        this.isSkipDisabled = true;
                        this.clonememoworkbookarray = deepCopy(this.memoworkbookarray);
                        if (this.clonememoworkbookarray && this.clonememoworkbookarray["fileDetails"][0]["sheetDetails"].length > 1) {
                            this.isSkipDisabled = false;
                        }
                        for (var key_fileDetails in this.clonememoworkbookarray["fileDetails"]) {
                            for (var key_sheetDetails in this.clonememoworkbookarray["fileDetails"][key_fileDetails]["sheetDetails"]) {
                                this.sheetNames.push(
                                    {
                                        sheetname: this.clonememoworkbookarray["fileDetails"][key_fileDetails]["sheetDetails"][key_sheetDetails]["sheetName"],
                                    }
                                );
                            }
                        }
                    } else {
                        this.loading = false;
                    }
                });
            },
            handleSkipEvent(e, workbookId) {
                if (document.getElementById('skip' + workbookId).classList.contains('skipbtntype')) {
                    document.getElementById('skip' + workbookId).classList.remove('skipbtntype');
                    document.getElementById('skip' + workbookId).classList.add('skipbtntype1');
                    document.getElementById('skip' + workbookId).textContent = "Add";
                    document.getElementById('box' + workbookId).style.backgroundColor = "lightgrey";
                    //removing row from cloned array
                    let i = this.clonememoworkbookarray["fileDetails"][0]["sheetDetails"].map(item => item["id"]).indexOf(workbookId);
                    this.clonememoworkbookarray["fileDetails"][0]["sheetDetails"].splice(i, 1);
                }
                else {
                    document.getElementById('skip' + workbookId).classList.remove('skipbtntype1');
                    document.getElementById('skip' + workbookId).classList.add('skipbtntype');
                    document.getElementById('skip' + workbookId).textContent = "Skip";
                    document.getElementById('box' + workbookId).style.backgroundColor = "";
                    //adding row back to cloned array
                    var retrievedArray = this.memoworkbookarray["fileDetails"][0]["sheetDetails"].filter(function (el) {
                        return el["id"] == workbookId;
                    });
                    this.clonememoworkbookarray["fileDetails"][0]["sheetDetails"].splice(1, 0, ...retrievedArray);
                }
            },
            Generate() {
                this.$validator.validateAll('generateForm').then(valid => {
                    if (valid) {
                        this.showMemowarning = false;
                        this.loading = true;
                        this.clonememoworkbookarray.clientName = this.selectedClient.text;
                        localStorage.setItem('ClientName', this.selectedClient.text)
                        this.clonememoworkbookarray.mappingId = this.selectedClient.id;
                        this.clonememoworkbookarray.AppName = 'memo';
                        this.clonememoworkbookarray.userName = localStorage.getItem('userName');
                        this.clonememoworkbookarray.userID = localStorage.getItem('userId');
                        this.clonememoworkbookarray.FirstName = localStorage.getItem('firstName');
                        this.clonememoworkbookarray.LastName = localStorage.getItem('lastName');
                        for (var key_MEMOclonesheetDetails in this.clonememoworkbookarray["fileDetails"][0]["sheetDetails"]) {
                            var MEMOcloneSheetName = this.clonememoworkbookarray["fileDetails"][0]["sheetDetails"][key_MEMOclonesheetDetails]["sheetName"];
                            for (var key_MEMOoriginalsheetDetails in this.memoworkbookarray["fileDetails"][0]["sheetDetails"]) {
                                var MEMOoriginalSheetName = this.memoworkbookarray["fileDetails"][0]["sheetDetails"][key_MEMOoriginalsheetDetails]["sheetName"];
                                if (MEMOcloneSheetName == MEMOoriginalSheetName) {
                                    this.clonememoworkbookarray.fileDetails[0].sheetDetails[key_MEMOclonesheetDetails].rowStart = this.memoworkbookarray.fileDetails[0].sheetDetails[key_MEMOoriginalsheetDetails].rowStart;
                                    this.clonememoworkbookarray.fileDetails[0].sheetDetails[key_MEMOclonesheetDetails].rowEnd = this.memoworkbookarray.fileDetails[0].sheetDetails[key_MEMOoriginalsheetDetails].rowEnd;
                                    this.clonememoworkbookarray.fileDetails[0].sheetDetails[key_MEMOclonesheetDetails].columnStart = this.memoworkbookarray.fileDetails[0].sheetDetails[key_MEMOoriginalsheetDetails].columnStart;
                                    this.clonememoworkbookarray.fileDetails[0].sheetDetails[key_MEMOclonesheetDetails].columnEnd = this.memoworkbookarray.fileDetails[0].sheetDetails[key_MEMOoriginalsheetDetails].columnEnd;
                                }
                            }
                        }
                        if (this.clonememoworkbookarray.memoTemplates.length !== 0) {
                            this.clonememoworkbookarray.memoTemplates.splice(0, 1);
                        }
                        var memojson = {
                            "place": this.place,
                            "date": this.date,
                            "sender1Name": this.sender1Name,
                            "sender1Designation": this.sender1Designation,
                            "sender2Name": this.sender2Name,
                            "sender2Designation": this.sender2Designation,
                            "recipientName": this.recipientName,
                            "addressLine1": this.addressLine1,
                            "addressLine2": this.addressLine2,
                            "addressLine3": this.addressLine3,
                        };
                        if (this.memoMessage) {
                            memojson['isForceFlag'] = 1;
                        }
                        this.clonememoworkbookarray.memoTemplates.push(memojson);
                        var saveJsonArray = JSON.stringify(this.clonememoworkbookarray); // converting array object into json
                        saveJsonArray = "[" + saveJsonArray + "]";
                        this.SaveDetails(saveJsonArray).then(Response => {
                            if (Response) {
                                if (Response.status == 200) {
                                    this.loading = false;
                                    this.MEMOSendDetails = Response.data;
                                    if (Response.data.message) {
                                        this.renderSendMEMODiv = false;
                                        this.memoMessage = Response.data.message;
                                        this.showUpdateWarning = true;
                                    }
                                    else {
                                        this.showUpdateWarning = false;
                                        this.memoMessage = '';
                                        this.memoClientName = Response.data.clientName;
                                        this.memoId = Response.data.memoID;
                                        localStorage.setItem('MemoId', this.memoId);
                                        this.memoName = Response.data.fileName;
                                        localStorage.setItem('FileName', this.memoName);
                                        this.memoLink = Response.data.filePath;
                                        localStorage.setItem('FilePathOfAttachment', this.memoLink);
                                        this.renderSendMEMODiv = true;
                                    }
                                } else {
                                    this.loading = false;
                                    this.showMemowarning = true;
                                }
                            }
                        }).catch(function () {
                            this.loading = false;
                            this.showMemowarning = true;
                        });
                    }
                })
            },
            Send() {
                this.$validator.validateAll('sendForm').then(valid => {
                    if (valid) {
                        this.sendloading = true;
                        var sendData = {
                            "id": localStorage.getItem('MemoId'),                            
                            "FromAddress": localStorage.getItem('userName'),
                            "ToAddress": this.mailto + ';' + localStorage.getItem('userName'),
                            "Subject": this.mailsubject,
                            "Body": this.mailbody,
                            "FileName": localStorage.getItem('FileName'),
                            "FilePathOfAttachment": '',
                            "ClientId": this.selectedClient.id,
                            "UserId": localStorage.getItem('userId'),
                            "Date": this.date,
                            "MemoLink": this.memoLink,
                            "MemoId": localStorage.getItem('MemoId')                          
                        };
                        this.SendMail(sendData).then(Response => {
                            if (Response) {
                                if (Response.status == 200 && !Response.isAxiosError) {
                                    //send response
                                    this.sendloading = false;
                                    this.showEmailSuccess = true;
                                }
                                else {
                                    this.sendloading = false;
                                    this.showEmailWarning = true;
                                }
                            }
                        });
                    }
                })
            }
        }
    };
</script>
<style scoped>
    .boxed {
        border: 1px solid rgb(211, 211, 211);
        padding: 10px;
        margin: 10px;
        border-radius: 5px;
    }

    .skipbtntype {
        background-color: #ffe600;
    }

    .skipbtntype1 {
        background-color: grey;
    }

    select {
        /* styling */
        background-color: white;
        border: thin solid grey;
        border-radius: 4px;
        display: inline-block;
        font: inherit;
        line-height: 1.5em;
        padding: 0.5em 3.5em 0.5em 1em;
        /* reset */
        margin: 0;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        -webkit-appearance: none;
        -moz-appearance: none;
        cursor: pointer;
    }

        select.selectarrow {
            background-image: linear-gradient(45deg, transparent 50%, gray 50%), linear-gradient(135deg, gray 50%, transparent 50%), linear-gradient(to right, #ccc, #ccc);
            background-position: calc(100% - 20px) calc(1em + 2px), calc(100% - 15px) calc(1em + 2px), calc(100% - 2.5em) 0.5em;
            background-size: 5px 5px, 5px 5px, 1px 1.5em;
            background-repeat: no-repeat;
        }

            select.selectarrow:focus {
                background-image: linear-gradient(45deg, green 50%, transparent 50%), linear-gradient(135deg, transparent 50%, green 50%), linear-gradient(to right, #ccc, #ccc);
                background-position: calc(100% - 15px) 1em, calc(100% - 20px) 1em, calc(100% - 2.5em) 0.5em;
                background-size: 5px 5px, 5px 5px, 1px 1.5em;
                background-repeat: no-repeat;
                border-color: green;
                outline: 0;
            }

        select:-moz-focusring {
            color: transparent;
            text-shadow: 0 0 0 #000;
        }

    .homebody {
        /* background-image: url("../../assets/city.jpg"); */
        background-color: #3333331a;
    }

    .input-control-border {
        border-color: #808080d9 !important
    }

    .label-font-design {
        color: #808080d9;
        font-weight: 700;
        font-family: sans-serif;
        font-size: 20px;
        font-size: -6px;
    }

    .form-control.error {
        border-color: #E84444;
        box-shadow: inset 0 1px 1px rgba(0,0,0,.075), 0 0 8px rgba(232,68,68,.6);
    }

    .is-invalid {
        border-color: #E84444;
        box-shadow: inset 0 1px 1px rgba(0,0,0,.075), 0 0 8px rgba(232,68,68,.6);
    }

    .emailMsg {
        width: 25%;
        margin-top: 6px;
        display: flex;
        justify-content: center;
    }

    .memoTitle {
        color: cornflowerblue;
        font-weight: bold;
    }
</style>